import React from 'react';
import KickImage from 'Reuseables/KickImage';
import moment from 'moment';

import { IPopularItemProps } from './PopularItem.definitions';

/** CSS import */
import Styles from './PopularItem.module.scss';
import { Link } from 'react-router-dom';

const PopularItem: React.FC<IPopularItemProps> = ({
  title,
  date,
  image,
  slug,
}: IPopularItemProps) => {
  return (
    <Link to={`/kickavenews/${slug}`}>
      <div className={Styles['wrapper']}>
        <div className={Styles['image-wrapper']}>
          <KickImage src={image} alt={title} className={Styles['image']} />
        </div>
        <div>
          <p className={Styles['title']}>{title}</p>
          <p className={Styles['date']}>
            {moment(date).format('MMMM DD, YYYY')}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default PopularItem;
